module.exports = __webpack_public_path__ + "static/media/icon-check-stroke.0f2a77a0.svg";